<template>
    <q-page class="q-pa-md">
        <charge_bee_invoices_monitoring_log_list ref="charge_bee_invoices_monitoring_log_list"></charge_bee_invoices_monitoring_log_list>
    </q-page>
</template>

<script>
    export { default } from './chargebeeinvoicesapplicationviewmodel-custom-screen.js'
</script>